import { FormControl, FormControlLabel, Grid, Radio, Box, Typography } from "@mui/material"
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HelpIcon from '@mui/icons-material/Help';

function BpRadio(props) {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={
        <CheckCircleIcon
          sx={{
            color: 'primary.mainBlue'
          }}
        />
      }
      icon={
        <RadioButtonUncheckedIcon
          sx={{
            color: 'primary.mediumGray'
          }}
        />
      }
      {...props}
    />
  );
}

const BaseCircleRadioGroup = ({ label, value, items, direction = 'row', onChange }) => {
  return (
    <FormControl
      sx={{
        width: '100%'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: '8px'
        }}
      >
        <Typography variant="h4" color="primary.darkGray">
          {label}
        </Typography>
        <HelpIcon
          sx={{
            fontSize: '20px',
            color: 'primary.mediumGray',
            ml: '8px'
          }}
        />
      </Box>
      <Grid container spacing='0px'>
        {items.map(((label) => (
          <Grid item xs={12} md={direction === 'row' ? 4 : 12} key={label}>
            <FormControlLabel
              value={label}
              checked={value === label}
              onChange={onChange}
              control={<BpRadio />}
              label={label}
              size="small"
              sx={{
                '& .MuiFormControlLabel-label': {
                  fontSize: '15px !important',
                  fontWeight: 500
                }
              }}
            />
          </Grid>
        )))}
      </Grid>
    </FormControl>
  )
}

export default BaseCircleRadioGroup